import PostsTableBody from './PostsTableBody';

export default PostsTableBody;
